(() => {
  function initialize(scope = document) {
    scope.querySelectorAll('[data-xr-plate-sets]').forEach(panel => {
      if (panel.dataset.initialized) return;
      panel.dataset.initialized = 'true';
      const form = document.getElementById(panel.dataset.formId);
      if (!form) return;
      let contents = form.querySelector('[data-xr-plate-contents]');
      if (!contents) {
        contents = document.createElement('input');
        contents.type = 'hidden';
        contents.name = 'properties[Set contents]';
        contents.dataset.xrPlateContents = 'true';
        form.appendChild(contents);
      }
      function update() {
        const selected = panel.querySelector('[data-xr-plate-option]:checked');
        contents.value = selected ? selected.dataset.contents : '';
      }
      panel.addEventListener('change', update);
      update();
    });
  }
  document.addEventListener('DOMContentLoaded', () => initialize());
  document.addEventListener('shopify:section:load', e => initialize(e.target));
  document.addEventListener('quickview:loaded', () => initialize());
})();
